import ENFJ from "../assets/catbti/ENFJ.png";
import ENFP from "../assets/catbti/ENFP.png";
import ENTJ from "../assets/catbti/ENTJ.png";
import ENTP from "../assets/catbti/ENTP.png";
import ESFJ from "../assets/catbti/ESFJ.png";
import ESFP from "../assets/catbti/ESFP.png";
import ESTJ from "../assets/catbti/ESTJ.png";
import ESTP from "../assets/catbti/ESTP.png";
import INFJ from "../assets/catbti/INFJ.png";
import INFP from "../assets/catbti/INFP.png";
import INTJ from "../assets/catbti/INTJ.png";
import INTP from "../assets/catbti/INTP.png";
import ISFJ from "../assets/catbti/ISFJ.png";
import ISFP from "../assets/catbti/ISFP.png";
import ISTJ from "../assets/catbti/ISTJ.png";
import ISTP from "../assets/catbti/ISTP.png";

const petbtiApi2 = [
  {
    INTJ: {
      id: "INTJ",
      subhead: "시크한 차도냥",
      subject: "호기심 덩어리 고집불통 대마왕",
      feature1: "#난 외롭다",
      feature2: "#삶이란 고독",
      feature3: "#다가오지 마!",
      nickname: "과학자형",
      img: INTJ,
      description: [
        {
          des: "저 인간이 날 좋아하는지 안 좋아하는지 파악가능하다!",
        },
        {
          des: "새로운 방식으로 캣타워를 타고 싶어.",
        },
        {
          des: "방해하지 마라! 나 지금 몰두하고 있다 냥!",
        },
        {
          des: "똑똑한 고양이, 확실하게 학습을 해요!",
        },
        {
          des: "내가 이 컵을 깨면 집사가 날 쳐다보겠지. ",
        },
        {
          des: "한 번 가진 신념은 절대 바꾸지 않는다. 냥.",
        },
      ],
      duo: [
        {
          img: ENTP,
          subhead: "ENTP",
          des: "모든 것이 궁금한 괴짜 사색가냥",
        },
      ],
      counter: [
        {
          img: ESFP,
          subhead: "ESFP",
          des: "호기심 대마왕 냥",
        },
      ],
    },
    INTP: {
      id: "INTP",
      subhead: "하나부터 열까지 탐색하는 똑똑냥",
      subject: "지식에 대한 끝없는 욕망",
      feature1: "#무심하지만",
      feature2: "#그거 다 관심",
      feature3: "#속을 알 수 없어",
      nickname: "아이디어뱅크형",
      img: INTP,
      description: [
        {
          des: "잠깐 생각에 잠겨 있겠다, 절대 멍때리는 거 아니다. 냥.",
        },
        {
          des: "관심사에 빠지면 전문가가 될 만큼 파고든다!",
        },
        {
          des: "집사는 이쯤에 온다. 오면 맛있는 걸 줄지도 몰라.",
        },
        {
          des: "내 영역을 벗어나면 뭐가 있을까.",
        },
        {
          des: "너는 그렇게 생각하냥? 그럼 난 반대로 생각한당! ",
        },
        {
          des: "절대 원하는 대로 해 주지는 않겠다 냥!",
        },
      ],
      duo: [
        {
          img: ENTJ,
          subhead: "ENTJ",
          des: "단호하고 철저한 단호박냥",
        },
      ],
      counter: [
        {
          img: ESFJ,
          subhead: "ESFJ ",
          des: "모두에게 친절한 신사숙녀 냥",
        },
      ],
    },
    INFJ: {
      id: "INFJ",
      subhead: "버티기의 달인 행운의 냥",
      subject: "싸움은 싫어! 평화로운게 좋아",
      feature1: "#고민상담전문냥",
      feature2: "#선의의 옹호냥",
      feature3: "#자신감 뿜뿜",
      nickname: "속을 알 수 없냥",
      img: INFJ,
      description: [
        {
          des: "집사를 대할 때에도 느긋하게 천천히.",
        },
        {
          des: "낯가림이 심하지만 눈치는 빨라!",
        },
        {
          des: "어떤 사람인지 파악하는 것이 중요해!",
        },
        {
          des: "뭐 하나에 꽂혀서 밥을 굶은 적도 있다!",
        },
        {
          des: "조용해 보이지만 속으로는 많은 생각을 하고 있지.",
        },
        {
          des: "불평등한 것은 싫어. 공평하게 나눠 줘! 집사도 한입, 나도 한입.",
        },
      ],
      duo: [
        {
          img: ENFP,
          subhead: "ENFP",
          des: "분위기 메이커 냥",
        },
      ],
      counter: [
        {
          img: ESTP,
          subhead: "ESTP",
          des: "착한 바부 냥",
        },
      ],
    },
    INFP: {
      id: "INFP",
      subhead: "공감능력킹왕짱 냥",
      subject: "상상의 나라로 풍~덩",
      feature1: "#다혈질 냥",
      feature2: "#게으름 냥",
      feature3: "#자유로움",
      nickname: "열정적인 중재자",
      img: INFP,
      description: [
        {
          des: "집사를 많이 좋아하니까 많이 좋아한다고 할래! 근데 부끄럽다!!",
        },
        {
          des: "내가 좋아하는 건 집사랑 집사가 주는 밥!",
        },
        {
          des: "집사야! 물은 무서운 거다 냥!!",
        },
        {
          des: "널 믿었는데 병원을 데려가다니 정말 있을 수 없는 일이 일어나고 말았다 냥.",
        },
        {
          des: "집사를 아주 좋아하고 잘 믿어요.",
        },
      ],
      duo: [
        {
          img: ENFJ,
          subhead: "ENFJ",
          des: "애교쟁이 냥",
        },
      ],
      counter: [
        {
          img: ESFJ,
          subhead: "ESFJ",
          des: "모두에게 친절한 신사숙녀 냥",
        },
      ],
    },
    ISTJ: {
      id: "ISTJ",
      subhead: "안전을 지키는 보디가드 냥",
      subject: "실수는 용납할 수 없는 원칙주의 냥",
      feature1: "#독특한 유머코드",
      feature2: "#잘난 척 가끔",
      feature3: "#책임감!",
      nickname: "세상의 소금형",
      img: ISTJ,
      description: [
        {
          des: "철벽 고양이.",
        },
        {
          des: "자기 표현을 확실히 해요.",
        },
        {
          des: "안정적인 공간을 좋아한다 냥.",
        },
        {
          des: "왜 내 장난감이 여기 있지? 분명 다른 자리에 있었는데?",
        },
        {
          des: "체계적이고 자신의 냄새가 가득한 곳이 좋아요!",
        },
        {
          des: "책임감 넘치는 고양이. 하지만 지쳐서 홀랑 도망가버릴 수도!",
        },
      ],
      duo: [
        {
          img: ESTP,
          subhead: "ESTP",
          des: "착한 바부 냥",
        },
      ],
      counter: [
        {
          img: ENFP,
          subhead: "ENFP",
          des: "분위기 메이커 냥",
        },
      ],
    },
    ISFJ: {
      id: "ISFJ",
      subhead: "따뜻한 우리집 수호자냥",
      subject: "혼자 있는 게 좋지만 싫어",
      feature1: "#오래보자냥",
      feature2: "#친하게 지내",
      feature3: "#지켜 줄게!",
      nickname: "임금뒷편의 권력형",
      img: ISFJ,
      description: [
        {
          des: "이거 먹어! 배고파 보인다 냥! 흥미 있는 것도 곧잘 양보해요.",
        },
        {
          des: "집사를 지킬 거라고 유심히 살펴요.",
        },
        {
          des: "부비부비가 제일 좋아요.",
        },
        {
          des: "주변을 챙겨주고 안전하고 행복한 삶을 살 수 있도록 노력하고 싶어요.",
        },
        {
          des: "낯선 환경에 처하는 일은 정말정말 싫다 냥.",
        },
        {
          des: "좋아하는 사람은 아주아주 오래 좋아!",
        },
      ],
      duo: [
        {
          img: ESFP,
          subhead: "ESFP",
          des: "호기심 대마왕 냥",
        },
      ],
      counter: [
        {
          img: ENTP,
          subhead: "ENTP",
          des: "모든 것이 궁금한 괴짜 사색가냥",
        },
      ],
    },
    ISTP: {
      id: "ISTP",
      subhead: "상황을 빠르게 캐치하는 눈치 100단 냥",
      subject: "조용하지만 적응력이 강한 가랑비",
      feature1: "#진지한 냥",
      feature2: "#쉬고 싶어",
      feature3: "#지식 많은 냥",
      nickname: "백과사전형",
      img: ISTP,
      description: [
        {
          des: "집안의 모든 물건은 냥냥이의 장난감이 될 수도 있다 냥.",
        },
        {
          des: "만사가 귀찮지만 하나에 꽂히면 그거만 할래요!",
        },
        {
          des: "잘해주는 사람은 나도 좋고! 날 싫어하는 사람은 나도 싫어! 확고한 표현을 해요!",
        },
        {
          des: "누구보다 발빠르게 행동하지.",
        },
        {
          des: "다른 일에는 관심 없어! 내가 싫으면 안 하고 좋으면 할 거야.",
        },
        {
          des: "어디로 튈지 모르는 천방지축! 반응 예상이 어려워요!",
        },
      ],
      duo: [
        {
          img: ESTJ,
          subhead: "ESTJ",
          des: "어려운 문제를 해결하는 똑똑냥",
        },
      ],
      counter: [
        {
          img: ENFJ,
          subhead: "ENFJ",
          des: "애교쟁이 냥",
        },
      ],
    },
    ISFP: {
      id: "ISFP",
      subhead: "새로운 것을 찾아다니는 모험가 냥",
      subject: "나는 얼리어답터 냥!",
      feature1: "#집이 좋아",
      feature2: "#귀찮아요",
      feature3: "#뒹굴뒹굴",
      nickname: "성인군자형",
      img: ISFP,
      description: [
        {
          des: "나는 매일 변화한다. 잠을 자러 갈 때면 오늘 아침 일어났을 때와는 다른 냥이 되었음을 확실히 느낀다 냥. -냥 딜런",
        },
        {
          des: "우리 편견 없는 삶을 살자!",
        },
        {
          des: "틀에 박힌 냥생보다는 자유롭게 새로운 것을 경험하면서 살거다 냥!",
        },
        {
          des: "모두와 사이 좋게 지내고 싶어! 갈등, 불화 싫어!",
        },
        {
          des: "나에게 늘 새롭고 좋은걸 경험시켜줘!",
        },
        {
          des: "하지만 혼자가 편할 수도?",
        },
      ],
      duo: [
        {
          img: ESFJ,
          subhead: "ESFJ",
          des: "모두에게 친절한 신사숙녀 냥",
        },
      ],
      counter: [
        {
          img: ENTJ,
          subhead: "ENTJ",
          des: "단호하고 철저한 단호박냥",
        },
      ],
    },
    ESTP: {
      id: "ESTP",
      subhead: "친구가 좋은 착한 바부 냥",
      subject: "한번 내 친구는 영원한 내 친구",
      feature1: "#마이웨이",
      feature2: "#서프라이즈",
      feature3: "#친구하자!",
      nickname: "인싸형",
      img: ESTP,
      description: [
        {
          des: "멋지게 진화하는 용사 냥!",
        },
        {
          des: "사부작거리는 걸 좋아하는 냥",
        },
        {
          des: "외향적인 성격으로 어디서든 적응을 잘하지!",
        },
        {
          des: "남들이 가지 않는 길! 침대 밑, 선반 아래, 구석구석! 다 갈 거야!",
        },
        {
          des: "즉각적인 행동력과 관찰력! 모기는 한 방에!",
        },
        {
          des: "내 안에 에너지가 흘러넘친다... 직접 경험하고 부딪히며 문제해결완료!",
        },
      ],
      duo: [
        {
          img: ISTJ,
          subhead: "ISTJ",
          des: "안전을 지키는 보디가드냥",
        },
      ],
      counter: [
        {
          img: INFJ,
          subhead: "INFJ",
          des: "행운의 냥",
        },
      ],
    },
    ESFP: {
      id: "ESFP",
      subhead: "호기심 대마왕 냥",
      subject: "새로운 모험을 향해 나아간다!",
      feature1: "#사랑에 태워진 냥",
      feature2: "#귀여운 척 냥",
      feature3: "#난 귀여워",
      nickname: "인맥왕",
      img: ESFP,
      description: [
        {
          des: "즐겁게 골골송을 부르고 싶다 냥.",
        },
        {
          des: "지금 이 순간을 즐기고 너도 같이 즐거웠으면 좋겠다 냥.",
        },
        {
          des: "집사가 왔네! 오늘도 파티야!",
        },
        {
          des: "어디에서나 즐길 수 있어요!",
        },
        {
          des: "즐거워 보이는 일은 고민 없이 바로 하자",
        },
        {
          des: "놀고 싶은데 친구들과 어울리지 못하는 경우 슬픔을 느껴요.",
        },
      ],
      duo: [
        {
          img: ISFJ,
          subhead: "ISFJ",
          des: "따뜻한 우리집 수호자냥",
        },
      ],
      counter: [
        {
          img: INTJ,
          subhead: "INTJ",
          des: "시크한 차도냥",
        },
      ],
    },

    ENTJ: {
      id: "ENTJ",
      subhead: "단호하고 철저한 단호박냥",
      subject: "너는 짖어라 나는 몰라",
      feature1: "#내가 짱!",
      feature2: "#슈퍼냥냥펀치",
      feature3: "#자신감최고!",
      nickname: "지도자형",
      img: ENTJ,
      description: [
        {
          des: "리더 고양이!",
        },
        {
          des: "이건 안 돼! 양보 불가능! 좋아하는 건 양보하지 않아요!",
        },
        {
          des: "집사의 교육이 아닌 내 성격에 맞게 체계적으로 살아갈 거야!",
        },
        {
          des: "높은 곳을 좋아해요! 더 높은 곳으로 도전하고 싶어요!",
        },
        {
          des: "1등으로 먹고 제일 먼저 놀거야",
        },
        {
          des: "무관심해 보이지만 언제나 집사 생각을 한답니다!",
        },
        {
          des: "오늘도 나만의 루틴이 있지! 에너지 뿜뿜! 난 위대한 고양이!",
        },
      ],
      duo: [
        {
          img: INTP,
          subhead: "INTP",
          des: "하나부터 열까지 탐색하는 똑똑냥",
        },
      ],
      counter: [
        {
          img: ISFP,
          subhead: "ISFP",
          des: "새로운 것을 찾아다니는 모험가냥",
        },
      ],
    },
    ENTP: {
      id: "ENTP",
      subhead: "모든 것이 궁금한 괴짜 사색가냥",
      subject: "다른 사람의 말은 한 귀로 흘리기",
      feature1: "#사랑강요",
      feature2: "#난 자유로워!",
      feature3: "#룰은 나다",
      nickname: "발명가형",
      img: ENTP,
      description: [
        {
          des: "집사는 이렇게 하라고 했지만 난 이렇게 하고 말겠어.",
        },
        {
          des: "규칙은 깨라고 있는 법이다 냥!",
        },
        {
          des: "혼을 내면 더 화를 내요! ",
        },
        {
          des: "대화의 주제는 오직 나야 나! 냥냥, 나를 봐!",
        },
        {
          des: "집사 말을 잘 들으면 집사가 날 좋아하는 게 느껴져. 근데 왜 말을 듣기 싫지?",
        },
        {
          des: "이 집은 내가 장악했다!",
        },
        {
          des: "가끔 하나의 장난감으로 종일 놀 수 있는 나는야 집착냥!",
        },
      ],
      duo: [
        {
          img: INTJ,
          subhead: "INTJ",
          des: "시크한 차도냥",
        },
      ],
      counter: [
        {
          img: ISFJ,
          subhead: "ISFJ",
          des: "따뜻한 우리집 수호자냥",
        },
      ],
    },
    ENFJ: {
      id: "ENFJ",
      subhead: "멋진 애교쟁이 냥",
      subject: "리액션 부자 리액션 최고!",
      feature1: "#시작무섭지만",
      feature2: "#나는 잘해",
      feature3: "#눈에 불켰어!",
      nickname: "언변능숙형",
      img: ENFJ,
      description: [
        {
          des: "나는 위대한 사명을 지닌 고양이.",
        },
        {
          des: "집사는 맨날 티비만 보면서 날 괴롭힌다! 티비를 못 보게 해야 한다 냥!",
        },
        {
          des: "올바른 일에 앞장서는 고양이!",
        },
        {
          des: "다른 고양이가 놀러오면 잘 지켜줘요!",
        },
        {
          des: "모범적으로 우리 집의 룰을 따르고 만들어요!",
        },
        {
          des: "냥들 사이의 연예인",
        },
      ],
      duo: [
        {
          img: INFP,
          subhead: "INFP",
          des: "공감능력킹왕짱 냥",
        },
      ],
      counter: [
        {
          img: ISTP,
          subhead: "ISTP",
          des: "상황을 빠르게 캐치하는 눈치 100단 냥",
        },
      ],
    },
    ENFP: {
      id: "ENFP",
      subhead: "분위기 메이커 냥",
      subject: "활발하고 순발력이 뛰어난 냥",
      feature1: "#정이넘쳐",
      feature2: "#관심 줘 냥!",
      feature3: "#우리는 친구!",
      nickname: "스파크형",
      img: ENFP,
      description: [
        {
          des: "나는 낭만 고양이이이! 자유로운 고양이!",
        },
        {
          des: "친구 냥과 깊은 유대 관계를 가져요.",
        },
        {
          des: "재밌는 일 없어? 재밌는 일 찾아 집을 이리저리 둘러보는 게 취미!",
        },
        {
          des: "집사랑 열정적으로 즐겁게 놀아요!",
        },
        {
          des: "우리 같이 즐거워지자! 냥!",
        },
        {
          des: "간식 시간을 사랑해! 제일 좋아하는 건 츄르지만 육포도 사랑해!",
        },
      ],
      duo: [
        {
          img: INFJ,
          subhead: "INFJ",
          des: "행운의 냥",
        },
      ],
      counter: [
        {
          img: ISTJ,
          subhead: "ISTJ",
          des: "안전을 지키는 보디가드냥",
        },
      ],
    },
    ESTJ: {
      id: "ESTJ",
      subhead: "어려운 문제를 해결하는 똑똑냥",
      subject: "인정받고 싶은 일벌레",
      feature1: "#완벽주의",
      feature2: "#할 거 많아!",
      feature3: "#뭐든 할래!",
      nickname: "사업가형",
      img: ESTJ,
      description: [
        {
          des: "이것은 옳다! 이것은 틀려! 확실하게 취향이 있어!",
        },
        {
          des: "우리 함께 뭘 했으면 좋겠어. 내 룰을 따르면서 말이지.",
        },
        {
          des: "집사야, 이건 내 선물이야! 마음에 들길 바라! 라며 아끼는 선물을 줄 수도?",
        },
        {
          des: "지금이 몇 시인데 아직까지 자고 있냐 냥! 냥펀치!",
        },
        {
          des: "위로보다는 해결방안을 알려줄게!",
        },
        {
          des: "이 시간이면 슬슬 새가 날라온다. 저 새를 언젠가 잡고야 말겠어. 우리 집은 지킨다 냥!",
        },
      ],
      duo: [
        {
          img: ISTP,
          subhead: "ISTP",
          des: "상황을 빠르게 캐치하는 눈치 100단 냥",
        },
      ],
      counter: [
        {
          img: INFP,
          subhead: "INFP",
          des: "공감능력킹왕짱 냥",
        },
      ],
    },
    ESFJ: {
      id: "ESFJ",
      subhead: "모두에게 친절한 신사숙녀 냥",
      subject: "매력적인 인기스타",
      feature1: "#기준 낮아냥",
      feature2: "#순한 나!",
      feature3: "#친구들아 날 봐!",
      nickname: "친선도모형",
      img: ESFJ,
      description: [
        {
          des: "다른 냥의 이야기에 관심이 많지.",
        },
        {
          des: "집사를 보살피려고 해요. 안전하게 보호할게!",
        },
        {
          des: "나보다 작은 냥과 사람을 잘 도와주는 나는 친절한 신사숙녀 냥!",
        },
        {
          des: "집사 즐거워? 친구들 즐거워 냥? 확인하러 다녀요!",
        },
        {
          des: "우리 친구들 모두 내 친구! 같이 즐거워지자 냥!",
        },
        {
          des: "리액션 최고! 엄살 최고!",
        },
      ],
      duo: [
        {
          img: ISFP,
          subhead: "ISFP",
          des: "새로운 것을 찾아다니는 모험가 냥",
        },
      ],
      counter: [
        {
          img: INTP,
          subhead: "INTP",
          des: "하나부터 열까지 탐색하는 똑똑냥",
        },
      ],
    },
  },
];

export default petbtiApi2;
